import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import Header from './Header';
import Footer from './Footer';
import CookieBanner from '../components/CookieBanner';

const Layout = ({ children, title, description, keywords, path }) => {
    // Initialize Google Analytics based on saved preferences
    useEffect(() => {
      const savedConsent = localStorage.getItem('cookie-consent');
      if (savedConsent) {
        const preferences = JSON.parse(savedConsent);
        if (preferences.analytics) {
          loadGoogleAnalytics();
        }
      }
    }, []);
  
    const loadGoogleAnalytics = () => {
      if (!window.gtag && !document.querySelector('[src*="googletagmanager.com/gtag/js"]')) {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-GECC2MB05W'; // Replace with your GA4 ID
        document.head.appendChild(script);
        
        script.onload = () => {
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);} // eslint-disable-line
          window.gtag = gtag;
          
          window.gtag('js', new Date()); // eslint-disable-line
          window.gtag('config', 'G-GECC2MB05W', { // eslint-disable-line
            anonymize_ip: true,
            cookie_flags: 'SameSite=None;Secure'
          });
        };
      } else if (window.gtag) {
        // If script already loaded, just update consent
        window.gtag('consent', 'update', { // eslint-disable-line
          'analytics_storage': 'granted'
        });
      }
    };
  
    // Disable Google Analytics and clear cookies
    const disableGoogleAnalytics = () => {
        // Update consent to denied
        if (window.gtag) {
          window.gtag('consent', 'update', { // eslint-disable-line
            'analytics_storage': 'denied'
          });
        }
        
        // Remove Google Analytics scripts from DOM
        const gaScripts = document.querySelectorAll('script[src*="googletagmanager.com"]');
        gaScripts.forEach(script => {
          script.remove();
        });
        
        // Clear window objects
        delete window.gtag;
        delete window.dataLayer;
        delete window.google_tag_manager;
        
        // Clear GA cookies
        const cookies = document.cookie.split(';');
        cookies.forEach(cookie => {
          const eqPos = cookie.indexOf('=');
          const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
          if (name.startsWith('_ga') || name.startsWith('_gid') || name.startsWith('_gat')) {
            // Clear for current domain
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
            // Clear for parent domain (with dot)
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${window.location.hostname}`;
            // Clear without domain
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
          }
        });
        
        // Stop any pending GA requests
        if (window.navigator && window.navigator.sendBeacon) {
          // Block further tracking calls
          const originalSendBeacon = window.navigator.sendBeacon;
          window.navigator.sendBeacon = function(url) {
            if (url.includes('google-analytics.com') || url.includes('googletagmanager.com')) {
              return false;
            }
            return originalSendBeacon.apply(this, arguments);
          };
        }
      };
  
    // Google Analytics Cookie Management
    const handleCookieUpdate = (preferences) => {
      if (preferences.analytics) {
        console.log('Analytics enabled');
        loadGoogleAnalytics();
      } else {
        console.log('Analytics disabled');
        disableGoogleAnalytics();
      }
    };
  
    return (
        <>
            <SEO
                title={title}
                description={description}
                keywords={keywords}
                path={path}
            />
            <div className="min-h-screen bg-white relative overflow-hidden">
                <Header />
                {children}
                <Footer onCookieUpdate={handleCookieUpdate} />
            </div>
            <CookieBanner
                onAccept={handleCookieUpdate}
                onDecline={handleCookieUpdate}
                onUpdatePreferences={handleCookieUpdate}
            />
        </>
    );
};

export default Layout;